<template>
  <div>
    <div class="login-logo clearfix">
      <div class="fl">
        <img
          class="pointer"
          :src="$pre + initProjectList.site_info.logo"
          alt="#"
          title="中共江西省委党校研究生报名系统"
          @click="routeHop('/')"
        />
      </div>
      <div class="fl">
        <img class="login-logo-line"  @click="routeHop('/')" src="../assets/images/fgline.png" alt="#" />
      </div>
      <div class="fl">
        <div class="pointer login-logo-r"  @click="routeHop('/')">
          中共江西省委党校研究生报名系统
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useMainStore } from "@/store/piniaStore";
export default {
  computed: {
    ...mapState(useMainStore, {
      initProjectList: "getInitProject",
    }),
  },
  data() {
    return {
    };
  },
  methods:{
     routeHop(url) {
      this.$router.push(url);
    },
  }
};
</script>

<style scoped>
.login-logo {
  width: 80%;
  margin: 10px auto;
}

.login-logo-line {
  margin: -5px 10px;
}

.login-logo-r {
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0;
  color: rgb(167, 165, 165);
}

.login-inner-text {
  padding: 10px;
  font-weight: bold;
}
.pointer {
  cursor: pointer;
}
</style>